import React, { useEffect, useRef } from 'react';
import { AssetWrapperProps } from 'src/app/atoms/Asset/AssetWrapper';
import { FeedPostAssetCarouselContainer } from './FeedPostAssetCarousel.styles';
import ImageCard from '../ImageCard/ImageCard';
import LeftAlignedCarousel from 'molecules/LeftAlignedCarousel/LeftAlignedCarousel';

export interface Post {
  href: string;
  image: AssetWrapperProps['imageProps'];
  imageMaxWidth?: number;
  title: string;
}

interface FeedPostAssetCarouselProps {
  posts: Post[];
}

const FeedPostAssetCarousel = ({ posts }: FeedPostAssetCarouselProps): JSX.Element => {
  const carouselRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!carouselRef.current) return;

    const { right } = carouselRef.current.getBoundingClientRect();

    carouselRef.current.style.setProperty('--feed-post-slider-width', `calc(100% + ${Math.round(right)}px)`);
  }, []);

  return (
    <FeedPostAssetCarouselContainer ref={carouselRef}>
      <LeftAlignedCarousel>
        {posts.map((post, index) => (
          <ImageCard
            key={index}
            className='image-card-item'
            image={post.image}
            imageMaxWidth={posts[0].imageMaxWidth}
            title={{
              type: 'paragraph',
              size: 'xl',
              text: post.title,
              fontWeight: 'font-weight-semibold',
            }}
            href={post.href}
          />
        ))}
      </LeftAlignedCarousel>
    </FeedPostAssetCarouselContainer>
  );
};

export default FeedPostAssetCarousel;
